export default {"src":"/_next/static/media/en-flag.c6d60d9c.svg","height":18,"width":24,"blurWidth":0,"blurHeight":0};